
<div [hidden]="!authService.isReadOnly()" style="text-align: center;">
  <br />
  Your role is <strong>Read Only</strong> and you have limited access to the system. Please contact your administrator.
</div>

<div [hidden]="authService.isReadOnly() || sharedService.loading">

<mat-card *ngIf="processingVouchers">
  <span>Loading Voucher Tasks...</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<mat-card *ngIf="processingHouseholds">
  <span>Loading Household Letter Tasks...</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<!-- Cards -->
<section *ngIf="!processingVouchers">
  <div fxFlex="50" fxFlex.lt-md="100">
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <mat-card
        [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.newApplications?.length == 0, 'bg-red-400':dashboardData.newApplications?.length > 0}">
        <mat-card-title class="f-s-12 f-w-100">New Applications</mat-card-title>
        <mat-card-content>
          <h2>{{dashboardData.newApplications?.length}}</h2>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <a [routerLink]="['/vouchers/import']">
        <mat-card
          [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.totalLubgwmaVoucherImports == 0, 'bg-red-400':dashboardData.totalLubgwmaVoucherImports > 0}">
          <mat-card-title class="f-s-12 f-w-100">New LUBGWMA Testing Voucher Imports</mat-card-title>
          <mat-card-content>
            <h2>{{dashboardData.totalLubgwmaVoucherImports}}</h2>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <a (click)="anchorToElement(voucherLetterTasks)" style="cursor: pointer;">
      <mat-card
        [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.lettersTasks.length == 0, 'bg-red-400':dashboardData.lettersTasks.length > 0}">
        <mat-card-title class="f-s-12 f-w-100">Voucher Letter Tasks</mat-card-title>
        <mat-card-content>
          <h2>{{dashboardData.lettersTasks.length}}</h2>
        </mat-card-content>
      </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <a (click)="anchorToElement(houseHoldLetterTasks)" style="cursor: pointer;">
        <mat-card
          [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.householdLetterTasks.length == 0, 'bg-red-400':dashboardData.householdLetterTasks.length > 0}">
          <mat-card-title class="f-s-12 f-w-100">Household Letter Tasks</mat-card-title>
          <mat-card-content>
            <h2>{{dashboardData.householdLetterTasks.length}}</h2>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <a [routerLink]="['/vouchers/reports/nitrate-exceedance']">
        <mat-card
          [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.totalNitrateExceedanceMissingIndicator == 0, 'bg-red-400':dashboardData.totalNitrateExceedanceMissingIndicator > 0}">
          <mat-card-title class="f-s-12 f-w-100">Nirtrate Exceedance Not Indicated</mat-card-title>
          <mat-card-content>
            <h2>{{dashboardData.totalNitrateExceedanceMissingIndicator}}</h2>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100">
      <a [routerLink]="['/vouchers/reports/exceedance-not-indicated']"> 
        <mat-card
          [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.totalVouchersWithExceedanceNotIndicated == 0, 'bg-red-400':dashboardData.totalVouchersWithExceedanceNotIndicated > 0}">
          <mat-card-title class="f-s-12 f-w-100">Voucher Exceedance But Not Indicated</mat-card-title>
          <mat-card-content>
            <h2>{{dashboardData.totalVouchersWithExceedanceNotIndicated}}</h2>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100"> 
        <a [routerLink]="['/households/interactions/householdInteractionsApprovalNeededReport']" > 
        <mat-card
          [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.totalHouseholdInteractionsApprovalNeeded == 0, 'bg-red-400':dashboardData.totalHouseholdInteractionsApprovalNeeded > 0}">
          <mat-card-title class="f-s-12 f-w-100">Household Interactions Approval Needed</mat-card-title>
          <mat-card-content>
            <h2>{{dashboardData.totalHouseholdInteractionsApprovalNeeded}}</h2>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
    <div class="matero-col" fxFlex.gt-sm="25" fxFlex.gt-xs="50" fxFlex="100"> 
      <a [routerLink]="['/household/reports/multiple-housing-units']" > 
      <mat-card
        [ngClass]="{'text-white': true, 'bg-indigo-500': dashboardData.totalHouseholdTiedToMultipleHousingUnits == 0, 'bg-red-400':dashboardData.totalHouseholdTiedToMultipleHousingUnits > 0}">
        <mat-card-title class="f-s-12 f-w-100">Households Tied to Multiple Housing Units</mat-card-title>
        <mat-card-content>
          <h2>{{dashboardData.totalHouseholdTiedToMultipleHousingUnits}}</h2>
        </mat-card-content>
      </mat-card>
    </a>
  </div>
  </div>
</section>

<!-- List of New Voucher Applications -->
<mat-card [hidden]="processingVouchers">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">New Voucher Applications
      ({{dashboardData.newApplications?.length}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableNewApplications($event)" placeholder="Filter New Applications" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceNewApplications" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-row>New Voucher Applications ({{dashboardData.totalNewVoucherApplications}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumnsNewApplications"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsNewApplications;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Application Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a [routerLink]="['/vouchers/application/edit/', result.voucherApplicationId]"
            title="Edit Voucher Application {{result.voucherApplicationId}}">{{result.voucherApplicationId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellAddress1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCity}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellZip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellZip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCounty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCounty}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellTag">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellTag}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicantContactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicantContactName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="selfGeneratedVoucherIdentifer">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Identifier</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.selfGeneratedVoucherIdentifer}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
      showFirstLastButtons></mat-paginator>
  </div>
</mat-card>

<!-- List of Newest Vouchers -->
<!-- <mat-card [hidden]="processingVouchers">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">New Vouchers Issued in the last 5 days
      ({{dashboardData.newestVouchers.length}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableNewest($event)" placeholder="Filter Newest Vouchers" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceNewest" matSort #TableSortNewest="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-row>New Vouchers Issued in last 5 days </mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumnsNewest"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsNewest;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editVoucher(result.voucherId)"
            title="Edit Voucher {{result.applicationIdentifier}}" style="cursor: pointer;">{{result.applicationIdentifier}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellAddress1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCity}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellZip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellZip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCounty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCounty}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellLabelTagNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellTag}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicantContactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicantContactName}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginatorNewest="matPaginator"
      showFirstLastButtons></mat-paginator>
  </div>
</mat-card> -->

<!-- List of voucher Letter Tasks -->
<div #voucherLetterTasks></div>
<mat-card [hidden]="processingVouchers">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Voucher Letter Tasks ({{dashboardData.lettersTasks.length}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableLetterTasks($event)" placeholder="Filter Voucher Letters" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceLetterTasks" matSort #TableSort2="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-row>Voucher Letter Tasks ({{dashboardData.lettersTasks.length}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumnsLetterTasks"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsLetterTasks;"></mat-row>
      <ng-container matColumnDef="voucherId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editVoucher(result.voucherId)"
            *ngIf="result.voucherIdentifier != null && result.voucherIdentifier.length > 0"
            title="Edit Voucher {{result.voucherIdentifier}}" style="cursor: pointer;">{{result.voucherIdentifier}}</a>

          <a (click)="editVoucherApplication(result.applicationId)"
            *ngIf="result.voucherIdentifier == null || result.voucherIdentifier.length == 0"
            title="Edit Voucher Application {{result.applicationId}}" style="cursor: pointer;">{{result.applicationId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="letterType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Letter Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span>{{result.letterType}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="complete">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Details</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span class="text-red-400">
            <span>{{result.incompleteDetails}}</span>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions"><mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <!-- Generated -->
          <span *ngIf="result.needsLetterGenerated && result.letterType != voucherService.notEligible"><mat-icon
              matTooltip="Generate Letter"
              (click)="generate(result.letterType, result.parameterResultId, result.sampleId, result.id, result.voucherId, result.applicationType)" style="cursor: pointer;">note_add</mat-icon>&nbsp;
          </span>
          <span *ngIf="result.needsLetterGenerated && result.letterType == voucherService.notEligible" style="cursor: pointer;"><mat-icon
              matTooltip="Generate Not Eligible Letter"
              (click)="generateNotEligible(result.letterType, result.applicationId, result.applicationType)" style="cursor: pointer;">note_add</mat-icon>&nbsp;
          </span>
          <!-- Attach -->
          <span *ngIf="result.missingAttachment && result.letterType != voucherService.notEligible"><mat-icon
              matTooltip="Attach Letter"
              (click)="attachVoucherLetter(result.id, result.voucherId, result.letterType, result.sampleId, result.parameterResultId)" style="cursor: pointer;">attach_file</mat-icon>&nbsp;
          </span>
          <span *ngIf="result.missingAttachment && result.letterType == voucherService.notEligible"><mat-icon
              matTooltip="Attach Not Eligible Letter"
              (click)="attachApplicationLetter(result.id, result.letterType)" style="cursor: pointer;">attach_file</mat-icon>&nbsp;
          </span>

          <!-- Sent info -->
          <span *ngIf="result.missingLetterSentInfo"><mat-icon matTooltip="Update Letter Sent Info"
              (click)="sendLetter(result.id, result.voucherId)" style="cursor: pointer;">beenhere</mat-icon>&nbsp;
          </span>

        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator2="matPaginator"
      showFirstLastButtons></mat-paginator>
  </div>
</mat-card>

<!-- List of Household Letter Tasks -->
  <div #houseHoldLetterTasks></div>
  <mat-card [hidden]="processingHouseholds">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Household Letter Tasks ({{dashboardData.householdLetterTasks.length}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableHouseholdLetterTasks($event)" placeholder="Filter Household Letters" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceHouseholdLetterTasks" matSort #TableSortHouseholdLetters="matSort"
      class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Household Letter Tasks ({{dashboardData.householdLetterTasks.length}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumnsHouseholdLetterTasks"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsHouseholdLetterTasks;"></mat-row>
      <ng-container matColumnDef="householdId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Household Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editHousehold(result.householdId)"
            title="Edit Household {{result.householdId}}" style="cursor: pointer;">{{result.householdId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="analyte">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.analyte}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="result">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Result</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.result}} {{result.unit}} 
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="address">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Mailing Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.address}} 
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="sampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editSample(result.sampleId)" title="Edit Sample {{result.sampleId}}" style="cursor: pointer;">{{result.sampleId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="letterType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Letter Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span>{{result.letterType}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="complete">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Details</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span class="text-red-400">
            <span>{{result.incompleteDetails}}</span>
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <!-- Generated -->
          <span *ngIf="result.needsLetterGenerated"><mat-icon matTooltip="Generate Household Letter"
              (click)="generateHouseholdLetter(result.letterType, result.parameterResultId, result.sampleId, result.householdId)" style="cursor: pointer;">note_add</mat-icon>&nbsp;
          </span>
          <!-- Attach -->
          <span *ngIf="result.missingAttachment"><mat-icon matTooltip="Attach Household Letter"
              (click)="attachHoulseholdLetter(result.householdId, result.letterType, result.sampleId, result.parameterResultId)" style="cursor: pointer;">attach_file</mat-icon>&nbsp;
          </span>

          <!-- Sent info -->
          <span *ngIf="result.missingLetterSentInfo"><mat-icon matTooltip="Update Household Letter Sent Info"
              (click)="sendHouseholdLetter(result.id)" style="cursor: pointer;">beenhere</mat-icon>&nbsp;
          </span>

        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginatorHouseholdLetters="matPaginator"
      showFirstLastButtons></mat-paginator>
  </div>
  </mat-card>

</div>